<template>
	<div class="content">
		<h3>密码修改</h3>
		<div class="item">
			<el-form ref="user" style="width:500px" :model="user" :rules="rules" label-width="100px">
				<el-form-item label="旧密码" prop="oldpw">
					<el-input v-model="user.oldpw"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="password">
					<el-input v-model="user.password"></el-input>
				</el-form-item>
				<el-form-item label="确认新密码" prop="confirm">
					<el-input v-model="user.confirm"></el-input>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button  @click="editpw" type="primary">保 存</el-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		var ruleconfirm = (rule, value, callback) => {
        	if (value === '') {
          		callback(new Error('请再次输入密码'));
        	} else if (value !== this.user.password) {
          		callback(new Error('两次输入密码不一致!'));
        	} else {
          		callback();
        	}
      		};
		return {
			user: {
				oldpw: '',
				password: '',
				confirm:'',
				userid:''
			},
			rules: {
        		oldpw:[
          			{ required: true,  message: '请输入旧密码', trigger: 'blur' }
        		],
        		password:[
          			{ required: true,  message: '请输入新密码', trigger: 'blur' }
				],
				confirm:[
					{ required: true,  message: '请输入确认新密码', trigger: 'blur' },
					{ validator: ruleconfirm,trigger: "blur"}
				],
				
      		},
		}
	},
	methods:{
		editpw(){
			this.$refs['user'].validate((valid) => {
          		if (valid) {
					  var user = JSON.parse(sessionStorage.getItem('user'));
					  this.user.userid=user.Usercode
					  this.$axios({
        				method: 'post',
        				url:'/FW/SettingUser.ashx',
        				params: {
          					action:"ChangePWD",
							UserId:this.user.userid,
							OldPwd:this.user.oldpw,
							NewPwd:this.user.password,
        				}
        			}).then(res=>{
          				if(res.Code==0){
            				this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'success'
							});
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
				}else{
					return false;
				}
			})
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 100px;
}
</style>


// WEBPACK FOOTER //
// src/pages/editPwd.vue